import { OrderStatus } from '@/types/order';

export const defaultCoinInfo = {
  contractAddress: '',
  volume: '',
  chainId: 0,
  decimal: 0,
  iconDayUrl: '',
  iconNightUrl: '',
  symbol: '',
  price: '',
};

export const PendingArr = [OrderStatus.PENDING, OrderStatus.INIT];
export const SuccessArr = [OrderStatus.SUCCESS];
export const FailArr = [
  OrderStatus.FAIL,
  OrderStatus.FAIL_PARTIAL,
  OrderStatus.CANCEL,
  OrderStatus.TIMEOUT,
];
